import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Hero from '@/components/home/Hero';
import Categories from '@/components/home/Categories';
import FeaturedProducts from '@/components/home/FeaturedProducts';
import CatalogSection from '@/components/home/CatalogSection';
import WhyUs from '@/components/home/WhyUs';

export default function HomePage() {
  const [showSplash, setShowSplash] = useState(true);

  // Sitenin kalitesini artıracak lüks harf animasyon ayarları
  const text = "AYZPLASTİK";
  
  const containerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08, // Her harf arasına 0.08 saniye gecikme koyar
        delayChildren: 0.2,
      },
    },
  };

  const letterVariants = {
    hidden: { y: "150%", opacity: 0, rotateX: -45 },
    visible: { 
      y: 0, 
      opacity: 1, 
      rotateX: 0,
      transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } 
    },
  };

  useEffect(() => {
    // Animasyon biraz daha detaylı olduğu için süreyi 3 saniyeye çıkardık
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000);
    
    if (showSplash) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'unset';
    };
  }, [showSplash]);

  return (
    <>
      {/* Sadece bu ekrana özel premium fontu (Montserrat) Google'dan anlık çekiyoruz */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;600&display=swap');
          .splash-font { font-family: 'Montserrat', sans-serif; }
        `}
      </style>

      <AnimatePresence mode="wait">
        {showSplash && (
          <motion.div
            key="splash-screen"
            exit={{ opacity: 0, y: "-100%", filter: "blur(10px)" }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            className="fixed inset-0 z-[9999] bg-brand-dark flex flex-col items-center justify-center overflow-hidden"
          >
            {/* Arka planda çok hafif dönen/büyüyen bir ışıltı efekti (Derinlik katar) */}
            <motion.div 
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1.2, opacity: 0.1 }}
              transition={{ duration: 3, ease: "linear" }}
              className="absolute w-96 h-96 bg-brand-pink rounded-full blur-[120px]"
            />

            {/* Harf Harf Beliren Metin */}
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              className="flex overflow-hidden relative z-10 splash-font"
            >
              {text.split("").map((char, index) => (
                <motion.span
                  key={index}
                  variants={letterVariants}
                  className="text-4xl md:text-6xl text-white font-semibold tracking-[0.2em] md:tracking-[0.3em]"
                  style={{ display: "inline-block" }}
                >
                  {char}
                </motion.span>
              ))}
            </motion.div>
            
            {/* İlerleyen İnce Çizgi */}
            <motion.div
              initial={{ scaleX: 0, opacity: 0 }}
              animate={{ scaleX: 1, opacity: 1 }}
              transition={{ duration: 1.5, ease: [0.76, 0, 0.24, 1], delay: 1 }}
              className="w-40 md:w-64 h-[1px] bg-white/40 mt-8 origin-center relative z-10"
            />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.main 
        data-testid="home-page"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: showSplash ? 0 : 1, y: showSplash ? 50 : 0 }}
        transition={{ duration: 1, ease: [0.76, 0, 0.24, 1], delay: 0.1 }}
      >
        <Hero />
        <Categories />
        <FeaturedProducts />
        <CatalogSection />
        <WhyUs />
      </motion.main>
    </>
  );
}